import { render } from "./ThanksPage.vue?vue&type=template&id=44e0bc15&scoped=true"
import script from "./ThanksPage.vue?vue&type=script&lang=js"
export * from "./ThanksPage.vue?vue&type=script&lang=js"

import "./ThanksPage.vue?vue&type=style&index=0&id=44e0bc15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44e0bc15"]])

export default __exports__